import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import {
  RefundStatus,
  refundStatusNameMap,
} from '../../interfaces/Refund/RefundStatus';

interface RefundStatusDropdownProps {
  label?: string;
  value: RefundStatus;
  onChange: (newStatus: RefundStatus) => void;
  loading?: boolean;
}

export const RefundStatusDropdown = (props: RefundStatusDropdownProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1.5,
        alignItems: 'center',
      }}
    >
      <FormControl size='small' fullWidth>
        {!!props.label && <InputLabel>{props.label}</InputLabel>}
        <Select
          label={props.label}
          value={props.value}
          onChange={(e) => props.onChange(e.target.value as RefundStatus)}
        >
          {Object.entries(refundStatusNameMap).map(([key, value]) => (
            <MenuItem key={key} value={key}>
              {value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {props.loading && <CircularProgress size={24} />}
    </Box>
  );
};
